import Vue from "vue";
import Vuex from "vuex";
import { auth_module } from "./storejs_modules/auth_store.js";
import { weather_module } from "./storejs_modules/weather_store.js";
import { analytics_module } from "./storejs_modules/analytics_store.js";


import axios from "axios";
import * as queries from "./graphql_hasura/queries";



Vue.use(Vuex);


const store = new Vuex.Store({
  modules: {
    weather: weather_module,
    auth: auth_module,
    analytics: analytics_module,
  },
  state: {
    cameras: [],
    studies: [],
    animals: [],

    video_cameras: [{ text: "No cameras found", value: null }],
    videos: [],
  },
  mutations: {



    set_cameras(state, payload) {
      state.cameras = payload;
    },
    set_studies(state, payload) {
      state.studies = payload;
    },
    set_animals(state, payload) {
      state.animals = payload;
    },

    set_video_cameras(state, payload) {
      state.video_cameras = payload;
    },
    set_videos(state, payload) {
      state.videos = payload;
    },
  },

  actions: {
    
    async ddb_get_cameras({ commit, state }) {
      try {
        let camera = (
          await axios.post(
            state.auth.hasura_params.url,
            {
              query: queries.camera,
              variables: {
                where: { deleted_at: { _is_null: true } },
              },
            },
            {
              headers: state.auth.hasura_params.headers,
            }
          )
        ).data.data.camera;
        commit("set_cameras", camera);
      } catch (error) {
        commit("set_cameras", null);
        console.error("Error fetching camera data:", error);
        throw error;
      }
    },

    async ddb_get_studies({ commit, state }) {
      try {
        let study = (
          await axios.post(
            state.auth.hasura_params.url,
            {
              query: queries.study,
              variables: {
                where: { deleted_at: { _is_null: true } },
              },
            },
            {
              headers: state.auth.hasura_params.headers,
            }
          )
        ).data.data.study;
        commit("set_studies", study);
      } catch (error) {
        commit("set_studies", null);
        console.error("Error fetching study data:", error);
        throw error;
      }
    },

    async ddb_get_animals({ commit, state }) {
      try {
        let animal = (
          await axios.post(
            state.auth.hasura_params.url,
            {
              query: queries.animal,
              variables: {
                where: { deleted_at: { _is_null: true } },
              },
            },
            {
              headers: state.auth.hasura_params.headers,
            }
          )
        ).data.data.animal;
        commit("set_animals", animal);
      } catch (error) {
        commit("set_animals", null);
        console.error("Error fetching animal data:", error);
        throw error;
      }
    },

    async ddb_get_video_cameras({ commit, state }, study) {
      try {
        let camera = (
          await axios.post(
            state.auth.hasura_params.url,
            {
              query: queries.camera,
              variables: {
                where: {
                  deleted_at: { _is_null: true },
                  id: { _regex: study },
                },
              },
            },
            {
              headers: state.auth.hasura_params.headers,
            }
          )
        ).data.data.camera;

        let camera_items = [];
        for (const i in camera) {
          camera_items.push({ text: camera[i].name, value: camera[i].id });
        }
        commit("set_video_cameras", camera_items);
      } catch (error) {
        commit("set_video_cameras", [
          { text: "No cameras found", value: null },
        ]);
        console.error("Error fetching camera data:", error);
        throw error;
      }
    },

    async ddb_get_videos({ commit, state }, params) {
      try {
        let where = {
          deleted_at: { _is_null: true },
          camera_id: { _regex: params.study },
          datetime: { _gte: params.dates[0], _lte: params.dates[1] },
        }
        if (params.selected_bookmark) {
          where.bookmarked = { _eq: true };
        }
        if (params.cameras) {
          where.camera_id = {_eq: params.cameras};
        }
        console.log(params)
        let video = (
          await axios.post(
            state.auth.hasura_params.url,
            {
              query: queries.video,
              variables: {
                where: where,
                order_by: { datetime: params.sort_order }
              },
            },
            {
              headers: state.auth.hasura_params.headers,
            }
          )
        ).data.data.video;
           // Process each video to create video_path
           video = video.map((v) => {
            const idParts = v.id.split("#"); // Split the ID by #
            const cameraId = idParts[0]; // First part is camera ID
            const date = new Date(idParts[1]); // Second part is the date
            // Extract date components
            const year = date.getUTCFullYear();
            const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are zero-based
            const day = String(date.getUTCDate()).padStart(2, "0");
            const hours = String(date.getUTCHours()).padStart(2, "0");
            const minutes = String(date.getUTCMinutes()).padStart(2, "0");
            const seconds = String(date.getUTCSeconds()).padStart(2, "0");
            // Format the file name
            const fileName = `${cameraId}_${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
            // Construct the video path
            const videoPath = `thumbnails/18e1d370-1071-707d-8d2c-842380209ba7/${cameraId}/${year}/${month}/${day}/${fileName}`;
            const hlsvideoPath = `hls/18e1d370-1071-707d-8d2c-842380209ba7/${cameraId}/${year}/${month}/${day}/${fileName}`;
            const inferencePath = `inference/18e1d370-1071-707d-8d2c-842380209ba7/${cameraId}/${year}/${month}/${day}/${fileName}`;
            return {
              ...v,
              thumbnailPath: videoPath,
              hlsvideoPath,
              inferencePath,
            };
          });

        commit("set_videos", video);
      } catch (error) {
        commit("set_videos", []);
        console.error("Error fetching camera data:", error);
        throw error;
      }
    },
  },

  getters: {

    cameras(state) {
      return state.cameras;
    },
    studies(state) {
      return state.studies;
    },
    animals(state) {
      return state.animals;
    },

    video_cameras(state) {
      return state.video_cameras;
    },
    videos(state) {
      return state.videos;
    },
  },
});

export default store;
